
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/addPreset/addSection/components/addSectionCategoryHeader.scss.css.virtualfile';
        module.exports = {"addSectionCategoryHeader":"_addSectionCategoryHeader_1x7sf_7"};